var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1945_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 5.19615C42.5692 1.98076 49.4308 1.98076 55 5.19615L76.8372 17.8038C82.4064 21.0192 85.8372 26.9615 85.8372 33.3923V58.6077C85.8372 65.0385 82.4064 70.9808 76.8372 74.1962L55 86.8038C49.4308 90.0192 42.5692 90.0192 37 86.8038L15.1628 74.1962C9.59361 70.9808 6.16283 65.0385 6.16283 58.6077V33.3923C6.16283 26.9615 9.59361 21.0192 15.1628 17.8038L37 5.19615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8334 25.3959L32.375 29.6875C30.1875 30.5209 28.3959 33.1042 28.3959 35.4584V52.3334C28.3959 54.0209 29.5 56.25 30.8542 57.25L42.3125 65.8125C44.3334 67.3334 47.6459 67.3334 49.6667 65.8125L61.125 57.25C62.4792 56.2292 63.5834 54.0209 63.5834 52.3334V35.4584C63.5834 33.125 61.7917 30.5209 59.6042 29.7084L48.1459 25.4167C46.9792 24.9584 45.0209 24.9584 43.8334 25.3959Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 54.8542C40.5416 54.8542 36.1041 50.4167 36.1041 44.9583C36.1041 39.5 40.5416 35.0625 46 35.0625C51.4583 35.0625 55.8958 39.5 55.8958 44.9583C55.8958 50.4167 51.4583 54.8542 46 54.8542ZM46 38.1875C42.2708 38.1875 39.2291 41.2292 39.2291 44.9583C39.2291 48.6875 42.2708 51.7292 46 51.7292C49.7291 51.7292 52.7708 48.6875 52.7708 44.9583C52.7708 41.2292 49.7291 38.1875 46 38.1875Z",
    fill: "#0071FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9167 48.6042C43.3958 48.6042 42.875 48.3333 42.5833 47.8542C42.1458 47.1042 42.375 46.1458 43.125 45.7083L44.7083 44.75C44.875 44.6458 44.9583 44.4792 44.9583 44.3125V42.375C44.9583 41.5208 45.6667 40.8125 46.5208 40.8125C47.375 40.8125 48.0833 41.5 48.0833 42.3542V44.2917C48.0833 45.5625 47.3958 46.7708 46.3125 47.4167L44.7083 48.375C44.4792 48.5417 44.1875 48.6042 43.9167 48.6042Z",
    fill: "#0071FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1945_2148",
    x: 0,
    y: 0,
    width: 92,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.579762 0 0 0 0 0.749505 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1945_2148"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.1820de626185f1a72227e749da46c899.svg";
export { ForwardRef as ReactComponent };